import { render } from "./PantryIngredientFoodListView.vue?vue&type=template&id=26091268&ts=true"
import script from "./PantryIngredientFoodListView.vue?vue&type=script&lang=ts"
export * from "./PantryIngredientFoodListView.vue?vue&type=script&lang=ts"

import "./PantryIngredientFoodListView.vue?vue&type=style&index=0&id=26091268&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__